import { Alert, Box, Button, Grid, Typography } from "@mui/material";
import ChipComCopyIcon from "../../../../../../../../../components/ChipComCopyIcon";
import BtnCompartilhar from "../../../../../../../../../components/BtnCompartilhar";
import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import axiosClient from "../../../../../../../../../lib/axios";
import LoadingApiQuery from "../../../../../../../../../components/LoadingApiQuery";
import { IRetornoEmitirBoleto } from "../../../../../../../../../types/mutations/financeiro/emitir-boleto";
import BtnImprimir from "./BtnImprimir";
import { formatarValorMonetario } from "../../../../../../../../../helpers/masks";
import BtnActionWrapper from "../../../../../../BtnActionWrapper";
import { PesquisarTitulosAReceber } from "../../../Step01";
import { enqueueSnackbar } from "notistack";

export default function EmitirBoletoBancario() {

  const { getValues, watch } = useFormContext();

  const actualStep = watch('stepper')

  const [dadosBoleto, setDadosBoleto] = useState<IRetornoEmitirBoleto | null>(null)
  const valorBoleto = getValues('total_atualizado')

  //queries e mutations
  const { mutate: emitirBoleto, isLoading } = useMutation({
    mutationKey: 'emitir-boleto',
    mutationFn: () => {
      const { selecionar_titulos } = getValues()

      return axiosClient.post(`/financeiro/contas-receber/emitir-boleto`, {
        titulos: selecionar_titulos.map((t: PesquisarTitulosAReceber) => t.id),
        loja_id: 1,
      })
    },
    onError: () => setDadosBoleto(null),
    onSuccess: ({ data }: { data: IRetornoEmitirBoleto }) => {
      setDadosBoleto(data)
      if (data.mensagem !== "") {
        enqueueSnackbar(data.mensagem, { variant: 'warning' })
      }
    }
  });
  //

  //Funções manipuladoras
  const handleBack = getValues('funcoesAux.onBack')
  //

  useEffect(() => {
    if (actualStep === 2) emitirBoleto()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualStep])

  return (
    <>
      <Box maxWidth={500}>
        {
          isLoading &&
          <Box width="100%"><LoadingApiQuery /></Box>
        }

        {
          (!isLoading && dadosBoleto) &&
          <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
              <Box display={'flex'} flexDirection={'column'}>
                <Box pb={2}>
                  <Typography variant='h6' fontWeight="bold">Emitir boleto bancário</Typography>
                  <Typography variant='subtitle2'>(O recebimento só será efetivado após a compensação bancária)</Typography>
                </Box>

                <ChipComCopyIcon title="Código de barras" codigo={dadosBoleto.linha_digitavel || "-"} />
              </Box>
            </Grid>

            <Grid size={{xs: 12}} gap={8}>
              <Box display={'flex'} gap={2}>
                <BtnImprimir pdfFileURI={dadosBoleto.boleto_url} />
                <BtnCompartilhar mensagem={`Segue abaixo a linha digitável do boleto no valor de ${formatarValorMonetario(valorBoleto)} para pagamento do(s) título(s):\n${dadosBoleto.linha_digitavel}`} />
              </Box>
            </Grid>

            <Grid size={{xs: 12}}>
              <Alert severity="warning">A emissão do boleto não garante a liquidação do título. O pagamento só será registrado após a compensação bancária</Alert>
            </Grid>
          </Grid>
        }
      </Box>
      <BtnActionWrapper>
        <Button onClick={handleBack} sx={{ pointerEvents: 'auto' }}>
          Voltar
        </Button>
      </BtnActionWrapper>
    </>
  )
}
